/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { ICellPresenter_$type } from "./ICellPresenter";
import { CellModel } from "./CellModel";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var CellPresenterBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellPresenterBase, _super);
    function CellPresenterBase(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    CellPresenterBase.prototype.modelUpdated = function (a) {
        this.b(a);
    };
    CellPresenterBase.prototype.b = function (a) {
        this.a.bj(a.c);
        this.a.bo(a.d);
        this.a.bc();
        if (a.aw(CellModel.dx) || a.aw(CellModel.d1) || a.aw(CellModel.dz) || a.aw(CellModel.dv)) {
            this.a.bq(a.dw, a.d0, a.dy, a.du);
        }
        if (a.ap) {
            this.a.bl(a.j2, a.dj, a.dp, a.dm, a.dh);
        }
        if (a.a7) {
            this.a.bm(a.ev, (a.d0 + a.du + a.dp + a.dh));
            this.a.bs(a.f8, (a.dw + a.dy + a.dj + a.dm));
        }
        if (a.ar) {
            if (a.a1 && !this.a.n) {
                this.a.a4();
            }
            if (a.aw(CellModel.dg)) {
                this.a.bk(a.j1.color);
            }
            if (a.aw(CellModel.dt)) {
                this.a.bp(a.bw);
            }
            if (a.av("IsCollapsable")) {
                this.a.o = a.aq;
                this.a.ax = a.ey;
                this.a.p = a.ay;
                this.a.bs(a.f8, (a.dw + a.dy + a.dj + a.dm));
            }
            if (a.av("Indent")) {
                this.a.ax = a.ey;
                this.a.bs(a.f8, (a.dw + a.dy + a.dj + a.dm));
            }
            if (a.av("IsExpanded")) {
                this.a.p = a.ay;
            }
        }
        if (a.a7 && a.a1) {
            this.a.b0(a);
        }
    };
    CellPresenterBase.prototype.c = function (a, b, c) {
        if (c == 0) {
            return a.color;
        }
        if (c == 1) {
            return b.color;
        }
        var d = BrushUtil.k(a, c, b, 0);
        return d.color;
    };
    Object.defineProperty(CellPresenterBase.prototype, "nativeCell", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPresenterBase.prototype, "isCanvasBased", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    CellPresenterBase.$t = markType(CellPresenterBase, 'CellPresenterBase', Base.$, [ICellPresenter_$type]);
    return CellPresenterBase;
}(Base));
export { CellPresenterBase };
//# sourceMappingURL=CellPresenterBase.js.map
